import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const resetScrollPosition = () => {
  const html = document.documentElement;
  const previousBehavior = html.style.scrollBehavior;

  html.style.scrollBehavior = "auto";
  window.scrollTo(0, 0);
  html.scrollTop = 0;
  document.body.scrollTop = 0;
  html.style.scrollBehavior = previousBehavior;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    resetScrollPosition();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
